module.exports = __webpack_public_path__ + "media/FR Background Video.f17e8fd0.mp4";